<div
  class="flex-1 p-2 border-2 border-slate-200 border-dashed rounded-md text-center"
>
  <span class="text-xs text-slate-900">{{
    "Questo testo verrà sostituito con la firma smart" | transloco
  }}</span>
</div>
